import { useState, useCallback } from 'react';

const EXIT_DURATION = 120;

export function useDialogClose(onClose: () => void) {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = useCallback(() => {
    if (isClosing) return;
    setIsClosing(true);
    setTimeout(onClose, EXIT_DURATION);
  }, [onClose, isClosing]);

  return { isClosing, handleClose };
}
